export default "__VITE_ASSET__Xyh8FOzR__"